import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, ButtonWithSpinner, Modal, Text } from '@reveni-io/reveni-ui'

import Instructions from './Instructions/Instructions'
import InvoicesCheckboxes from './InvoicesCheckboxes/InvoicesCheckboxes'
import ReturnLabelCheckboxes from './ReturnLabelCheckboxes/ReturnLabelCheckboxes'
import * as Styles from './styles'

const SendInstructionsModal = ({
  show,
  onClose,
  steps,
  returnLabels,
  invoices,
  onSendInstructions,
  sendingInstructions,
  numReturnLabels,
}) => {
  const { t } = useTranslation()
  const [returnLabelsChecked, setReturnLabelsChecked] = useState([])
  const [invoicesChecked, setInvoicesChecked] = useState([])
  const [customsDeclarationChecked, setCustomsDeclarationChecked] = useState(false)

  useEffect(() => {
    if (show) {
      const returnLabelsToCheck = returnLabels?.slice(0, numReturnLabels)
      setReturnLabelsChecked(returnLabelsToCheck?.map(label => label.id) || [])
      setInvoicesChecked([])
      setCustomsDeclarationChecked(false)
    }
  }, [numReturnLabels, returnLabels, show])

  const handleCheckReturnLabel = returnLabelId => {
    if (returnLabelsChecked.includes(returnLabelId)) {
      setReturnLabelsChecked(returnLabelsChecked.filter(id => id !== returnLabelId))
    } else {
      setReturnLabelsChecked([...returnLabelsChecked, returnLabelId])
    }
  }

  const handleCheckInvoice = invoice => {
    if (invoicesChecked.includes(invoice)) {
      setInvoicesChecked(invoicesChecked.filter(inv => inv !== invoice))
    } else {
      setInvoicesChecked([...invoicesChecked, invoice])
    }
  }

  const handleSendInstructions = () => {
    onSendInstructions({
      returnLabels: returnLabelsChecked,
      invoices: invoicesChecked,
      customsDeclaration: customsDeclarationChecked,
    })
  }

  return (
    <Modal title={t('Reenviar instrucciones de devolución')} onClose={onClose} show={show} size="l">
      <Styles.MainContainer>
        <Styles.InstructionsContainer>
          <Text type="bodyMRegular">
            {t('Reenvía las instrucciones y etiquetas de envío al cliente para que pueda realizar su devolución')}:
          </Text>
          <Instructions steps={steps || []} />
        </Styles.InstructionsContainer>
        <ReturnLabelCheckboxes
          returnLabels={returnLabels || []}
          returnLabelsChecked={returnLabelsChecked}
          onCheckReturnLabel={handleCheckReturnLabel}
          customsDeclarationChecked={customsDeclarationChecked}
          onCheckCustomsDeclaration={setCustomsDeclarationChecked}
        />
        <InvoicesCheckboxes invoices={invoices} invoicesChecked={invoicesChecked} onCheckInvoice={handleCheckInvoice} />
        <Styles.ActionsContainer>
          <Button onClick={onClose} variant="outlined" fullWidth>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            fullWidth
            defaultLabel={t('Enviar')}
            loadingLabel={t('Enviando')}
            loading={sendingInstructions}
            disabled={sendingInstructions}
            onClick={handleSendInstructions}
          />
        </Styles.ActionsContainer>
      </Styles.MainContainer>
    </Modal>
  )
}

export default SendInstructionsModal
